import React from "react";
import {
  Box,
  Heading,
  Text,
  VStack,
  List,
  ListItem,
  ListIcon,
} from "@chakra-ui/react";
import { FaCheckCircle, FaTools } from "react-icons/fa";

const PatchDrywallPage = () => {
  return (
    <Box minH="100vh" bg="white">
      {/* Hero Section */}
      <Box
        bg="white"
        py={{ base: 16, md: 20 }}
        px={{ base: 6, md: 12 }}
        textAlign="center"
      >
        <Heading
          as="h1"
          fontSize={{ base: "4xl", md: "5xl" }}
          fontWeight="800"
          color="gray.900"
          mb={6}
          fontFamily="'Work Sans', sans-serif"
        >
          How to Patch Small Holes in Drywall
        </Heading>
        <Text
          fontSize={{ base: "lg", md: "xl" }}
          color="gray.600"
          maxW="2xl"
          mx="auto"
        >
          Small holes in drywall can occur from nails, screws, or minor impacts.
          Fortunately, patching them is a straightforward task. Follow this
          guide to restore your walls to their original condition!
        </Text>
      </Box>

      {/* Content Section */}
      <Box bg="gray.50" py={{ base: 12, md: 16 }} px={{ base: 6, md: 12 }}>
        <Box maxW="1000px" mx="auto">
          {/* Tools & Materials Section */}
          <Box
            mb={12}
            p={8}
            bg="white"
            border="1px solid"
            borderColor="gray.200"
            borderRadius="xl"
            boxShadow="sm"
          >
            <Heading
              as="h2"
              fontSize="2xl"
              mb={4}
              color="gray.900"
              fontWeight="700"
            >
              Tools & Materials You'll Need
            </Heading>
            <List spacing={3}>
              <ListItem color="gray.700">
                <ListIcon as={FaTools} color="orange.500" />
                Patch Kit (or Spackle)
              </ListItem>
              <ListItem color="gray.700">
                <ListIcon as={FaTools} color="orange.500" />
                Putty Knife
              </ListItem>
              <ListItem color="gray.700">
                <ListIcon as={FaTools} color="orange.500" />
                Sandpaper (Fine Grit)
              </ListItem>
              <ListItem color="gray.700">
                <ListIcon as={FaTools} color="orange.500" />
                Paint (optional)
              </ListItem>
            </List>
          </Box>

          {/* Step-by-Step Instructions */}
          <VStack align="start" spacing={8} mb={8}>
            {/* Step 1 */}
            <Box>
              <Heading
                as="h2"
                fontSize="2xl"
                color="gray.900"
                fontWeight="700"
                mb={2}
              >
                Step 1: Clean the Area
              </Heading>
              <Text fontSize="lg" color="gray.600" mb={4}>
                Start by cleaning the area around the hole to remove any dust or
                loose debris. This will help the patch adhere better.
              </Text>
            </Box>

            {/* Step 2 */}
            <Box>
              <Heading
                as="h2"
                fontSize="2xl"
                color="gray.900"
                fontWeight="700"
                mb={2}
              >
                Step 2: Apply the Patch
              </Heading>
              <Text fontSize="lg" color="gray.600" mb={4}>
                Using a putty knife, apply the patching compound over the hole.
                Ensure it’s smooth and evenly spread. For larger holes, consider
                using a patch kit.
              </Text>
            </Box>

            {/* Step 3 */}
            <Box>
              <Heading
                as="h2"
                fontSize="2xl"
                color="gray.900"
                fontWeight="700"
                mb={2}
              >
                Step 3: Let It Dry
              </Heading>
              <Text fontSize="lg" color="gray.600" mb={4}>
                Allow the patching compound to dry completely according to the
                manufacturer’s instructions. This usually takes a few hours.
              </Text>
            </Box>

            {/* Step 4 */}
            <Box>
              <Heading
                as="h2"
                fontSize="2xl"
                color="gray.900"
                fontWeight="700"
                mb={2}
              >
                Step 4: Sand and Paint
              </Heading>
              <Text fontSize="lg" color="gray.600" mb={4}>
                Once dry, use fine-grit sandpaper to smooth the patched area. If
                necessary, touch up the paint to match the rest of the wall.
              </Text>
            </Box>
          </VStack>
        </Box>
      </Box>

      {/* Final Message Section */}
      <Box
        bg="white"
        py={{ base: 12, md: 16 }}
        px={{ base: 6, md: 12 }}
        textAlign="center"
      >
        <Text
          fontSize={{ base: "xl", md: "2xl" }}
          fontWeight="600"
          color="gray.800"
          maxW="3xl"
          mx="auto"
        >
          Congratulations! You’ve successfully patched the small hole in your
          drywall. Enjoy your restored wall!
        </Text>
      </Box>
    </Box>
  );
};

export default PatchDrywallPage;
